import { Button, ButtonProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface APButtonProps {
  to: string
}


const WrappedButton: React.FC<{ to: string } & ButtonProps> = ({ to, ...props }) => {
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault(); // Prevent default link behavior
    navigate(to);
  };

  return <Button {...props} data-testid="linkBtn" onClick={handleClick} />;
};

const APLinkButton: React.FC<APButtonProps & ButtonProps> = ({ to, ...otherProps }) => {
  return <WrappedButton to={to} {...otherProps} />;
};

export default APLinkButton;
